import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115e0945"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Upcoming Races ")
const _hoisted_2 = {
  href: "https://docs.houndrace.com/houndrace-docs/gameplay/racing",
  target: "_blank"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" SEARCH ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Connect with Metamask in order to view your races. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_icon = _resolveComponent("info-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_icon_wrapper = _resolveComponent("n-icon-wrapper")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_n_input_number = _resolveComponent("n-input-number")!
  const _component_n_input_group = _resolveComponent("n-input-group")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_join_races_table = _resolveComponent("join-races-table")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_my_queues = _resolveComponent("my-queues")!
  const _component_my_races = _resolveComponent("my-races")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_live_races_table = _resolveComponent("live-races-table")!
  const _component_search_icon = _resolveComponent("search-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_h3, {
      class: "thick-text",
      style: {"padding-left":"1.5rem"}
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_n_icon_wrapper, {
            "border-radius": "100%",
            size: "14",
            style: {"margin-left":".1rem","background":"transparent","border":"1px solid white"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_icon, {
                color: "white",
                size: "10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_info_icon)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_n_form, {
      model: _ctx.filtersModel,
      ref: "formRef",
      class: "filter-form-mobile",
      onSubmit: _withModifiers(_ctx.search, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_form_item, {
          label: "Ticket",
          path: "ticketPrice"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_input_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_input_number, {
                  step: 0.001,
                  value: _ctx.filtersModel.minTicketPrice,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtersModel.minTicketPrice) = $event)),
                  placeholder: "Min",
                  min: "0"
                }, null, 8, ["step", "value"]),
                _createVNode(_component_n_input_number, {
                  step: 0.001,
                  value: _ctx.filtersModel.maxTicketPrice,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersModel.maxTicketPrice) = $event)),
                  placeholder: "Max",
                  min: "0"
                }, null, 8, ["step", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_n_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              style: {"width":"100%"},
              "attr-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "onSubmit"]),
    _createVNode(_component_n_tabs, null, {
      suffix: _withCtx(() => [
        _createVNode(_component_n_form, {
          model: _ctx.filtersModel,
          ref: "formRef",
          "label-placement": "left",
          inline: "",
          class: "filter-form",
          onSubmit: _withModifiers(_ctx.search, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_form_item, {
              label: "Ticket",
              path: "ticketPrice",
              style: {"width":"20rem"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_input_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input_number, {
                      step: 0.001,
                      value: _ctx.filtersModel.minTicketPrice,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtersModel.minTicketPrice) = $event)),
                      placeholder: "Min",
                      min: "0"
                    }, null, 8, ["step", "value"]),
                    _createVNode(_component_n_input_number, {
                      step: 0.001,
                      value: _ctx.filtersModel.maxTicketPrice,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtersModel.maxTicketPrice) = $event)),
                      placeholder: "Max",
                      min: "0"
                    }, null, 8, ["step", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_n_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, {
                  circle: "",
                  "attr-type": "submit"
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_n_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_search_icon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onSubmit"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_n_tab_pane, {
          tab: "JOIN",
          name: "join",
          "tab-props": { style: { marginLeft: '1.5rem' } }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_join_races_table)
          ]),
          _: 1
        }, 8, ["tab-props"]),
        _createVNode(_component_n_tab_pane, {
          tab: "MY RACES",
          name: "my-races"
        }, {
          default: _withCtx(() => [
            (_ctx.ethReactive.initialized)
              ? (_openBlock(), _createBlock(_component_n_tabs, {
                  key: 0,
                  type: "card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_tab_pane, {
                      tab: "QUEUES",
                      name: "queues"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_queues)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_n_tab_pane, {
                      tab: "RACES",
                      name: "races"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_races)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_n_alert, {
                  key: 1,
                  title: "Allow Connection",
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_n_tab_pane, {
          tab: "LIVE",
          name: "live"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_live_races_table)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}